var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: (_vm.prefixCls + "-nav-item-group")
  }, [_c('div', {
    class: (_vm.prefixCls + "-nav-item-group__title"),
    style: ({
      paddingLeft: _vm.levelPadding + 'px'
    })
  }, [(!_vm.$slots.title) ? [_vm._v(_vm._s(_vm.title))] : _vm._t("title")], 2), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5691cf52", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5691cf52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Nav/n3NavGroup.vue
// module id = 630
// module chunks = 0 1